import UpgradeList from "./components/UpgradeList.vue";
// import applicationReport from "./components/applicationReport";
import virtualView from "@/router/virtualView";

export default {
  path: "upgrade",
  component: virtualView,
  children: [
    {
      path: "",
      name: "Upgrade Review",
      redirect: "application/list",
    },
    {
      path: "list/:stage?",
      name: "Upgrade List",
      component: UpgradeList,
    },
    // {
    //   path: "reports",
    //   name: "Upgrade Reports",
    //   component: applicationReport,
    // },
  ],
};
